import { IChecklist } from 'features/inventory';
import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';

class EquipmentCheckListService extends BaseService<IChecklist> {
  constructor() {
    super('checklists');
    this.canDelete = true;
  }

  public async createFromTemplate(payload: any) {
    const res = await axiosPrivate.post('checklists/create_from_template/', payload);

    return res.data;
  }

  public async toggleItemState(itemId: number, currentlyCompleted: boolean): Promise<any> {
    const action = currentlyCompleted ? 'uncomplete' : 'complete';

    const res = await axiosPrivate.post(`checklist-items/${itemId}/${action}/`);
    return res.data;
  }

  public async completeAllSectionItems(sectionId: number): Promise<any> {
    const res = await axiosPrivate.post(`checklist-sections/${sectionId}/complete_all_items/`);
    return res.data;
  }
}

export const equipmentCheckListService = new EquipmentCheckListService();
